import React, {useCallback, useState} from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';
import {pluralize} from '@pb/kit-formatters';

import {useRemoveConferences} from './useRemoveConferences';

type Props = {
    userId: number,
    conferenceIds: number[],
    onSuccess: () => void,
    onClose: () => void,
};

export const RemoveConferencesModal = ({userId, conferenceIds, onClose, onSuccess}: Props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const {busy, event} = useRemoveConferences({conferenceIds, userId, onSuccess, onFail: setErrorMessage});

    const removeConferences = useCallback(() => {
        event();
    }, [event]);

    return (
        <>
            <DialogHeader onClose={onClose}>
                Remove From Conference
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                {errorMessage ? <Message color="error">{errorMessage}</Message> : null}
                Are you sure you want to remove the user from the selected {
                    pluralize('conference[s]', conferenceIds.length)
                }?
            </DialogMain>
            <DialogFooter>
                <Group>
                    <Button busy={busy} variant="Type.PRIMARY" onClick={removeConferences}>
                        Remove
                    </Button>
                    <Button variant="Type.SECONDARY" onClick={onClose}>
                        Cancel
                    </Button>
                </Group>
            </DialogFooter>
        </>
    );
};
